export const NotificationResultMeta = [
  { id: 0, key: "InProgress",  label: "In progress",  type: "wait" },
  { id: 1, key: "Completed",   label: "Completed",   type: "success" },
  { id: 2, key: "Failed",      label: "Failed",      type: "error" },
  { id: 3, key: "Unknown",     label: "Unknown",     type: "error" },

  { id: 4, key: "Queued",      label: "Queued",      type: "wait" },
  { id: 5, key: "Sending",     label: "Sending",     type: "wait" },
  { id: 6, key: "Sent",        label: "Sent",        type: "wait" },

  { id: 7, key: "Delivered",   label: "Delivered",   type: "success" },
  { id: 8, key: "Undelivered", label: "Undelivered", type: "error" },

  { id:9, key: "Receiving",   label: "Receiving",   type: "wait" },
  { id:10, key: "Received",    label: "Received",    type: "success" },

  { id:11, key: "Accepted",    label: "Accepted",    type: "wait" },
  { id:12, key: "Scheduled",   label: "Scheduled",   type: "wait" },

  { id:13, key: "Read",        label: "Read",        type: "success" },
  { id:14, key: "Canceled",    label: "Canceled",    type: "error" },

  { id:15, key: "Ringing",     label: "Ringing",     type: "wait" },
  { id:16, key: "Busy",        label: "Busy",        type: "error" },
  { id:17, key: "NoAnswer",    label: "No answer",   type: "error" },
];

export const NotificationResultMetaMap = new Map(
  NotificationResultMeta.map(x => [x.id, x])
);
